import { BaseService } from '@/modules/Core/services/BaseService'
import type { ICitaOdontologicas } from '@/modules/Asistencial/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { IHistoryOdontograma } from '../interfaces/IOdontograma'
import type { IConfOdontogramas } from '@/modules/Configuracion/interfaces'
export class OdontologicaService extends BaseService<ICitaOdontologicas> {
  constructor () {
    super({
      baseUrl: 'scheduling/dental/'
    })
  }
  async listOdontologicas (
    cittId: number,
    coodId: number,
    withAnterior: boolean = false
  ): Promise<AxiosResponse<IResponseApi<ICitaOdontologicas[]>>> {
    return this.http.get<IResponseApi<ICitaOdontologicas[]>>(
      `/list/${cittId}/${coodId}?withAnterior=${withAnterior}`
    )
  }
  async existsOdontologicas (
    cittId: number
  ): Promise<AxiosResponse<IResponseApi<IConfOdontogramas[]>>> {
    return this.http.get<IResponseApi<IConfOdontogramas[]>>(
      `/exists/${cittId}`
    )
  }
  async listHistory (
    cittId: number,
    coodId: number,
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IHistoryOdontograma[]>>> {
    return this.http.get<IResponseApi<IHistoryOdontograma[]>>(
      `/history/${cittId}/${coodId}`, { params }
    )
  }
  
  async createOdontograma (
    cittId: number,
    coodId: number,
    data: ICitaOdontologicas[]
  ): Promise<AxiosResponse<IResponseApi<ICitaOdontologicas[]>>> {
    return this.http.post<IResponseApi<ICitaOdontologicas[]>>(
      `/create-multi/${cittId}/${coodId}`,
      data
    )
  }
}
